import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'select2/dist/js/select2.min.js';
import App from "./app/App";
import "./index.scss";
import "./shared/styles/ui.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { WishlistProvider } from "./features/wishlist/context/WishlistContext";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 
  <WishlistProvider>
  <ToastContainer position="top-right" autoClose={3000} />
    <App />
  </WishlistProvider>
  
);

